import { render, staticRenderFns } from "./Page-Tester.vue?vue&type=template&id=4194f3ae&"
import script from "./Page-Tester.vue?vue&type=script&lang=js&"
export * from "./Page-Tester.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports